var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            border: "",
            "header-cell-style": { background: "#f2f2f2", color: "black" },
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("operationCenter.ind"),
              width: "60px",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.$index + 1))])]
                },
              },
            ]),
          }),
          _vm._l(_vm.tableColumn, function (item, index) {
            return _c("el-table-column", {
              key: index,
              attrs: {
                label: item.label,
                prop: item.prop,
                "min-width": item.minWidth,
                align: item.align,
                fixed: item.fixed,
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        item.prop === "status"
                          ? _c(
                              "div",
                              [
                                scope.row.status === 1
                                  ? _c(
                                      "el-tag",
                                      {
                                        attrs: {
                                          size: "mini",
                                          type: "success",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t("GlobalSetObj.enable")
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                scope.row.status === 0
                                  ? _c(
                                      "el-tag",
                                      {
                                        attrs: { size: "mini", type: "danger" },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t("GlobalSetObj.disable")
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                scope.row.status === 2
                                  ? _c(
                                      "el-tag",
                                      { attrs: { size: "mini", type: "info" } },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t("collectionCenter.Stored")
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            )
                          : _c("div", [
                              _vm._v(
                                " " + _vm._s(scope.row[item.prop] || "-") + " "
                              ),
                            ]),
                      ]
                    },
                  },
                ],
                null,
                true
              ),
            })
          }),
          _c("el-table-column", {
            attrs: {
              fixed: "right",
              label: _vm.$t("operationCenter.operate"),
              width: "200",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "permit",
                            rawName: "v-permit:remove",
                            value: "btn:invoiceCenter:pushConfiguration:view",
                            expression:
                              "'btn:invoiceCenter:pushConfiguration:view'",
                            arg: "remove",
                          },
                        ],
                        attrs: { type: "text", size: "mini" },
                        on: {
                          click: function ($event) {
                            return _vm.handleView(scope.row)
                          },
                        },
                      },
                      [
                        _c(
                          "span",
                          { staticStyle: { color: "#409eff !important" } },
                          [_vm._v(_vm._s(_vm.$t("GlobalSetObj.View")))]
                        ),
                      ]
                    ),
                    scope.row.status === 0 || scope.row.status === 2
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "permit",
                                rawName: "v-permit:remove",
                                value:
                                  "btn:invoiceCenter:pushConfiguration:edit",
                                expression:
                                  "'btn:invoiceCenter:pushConfiguration:edit'",
                                arg: "remove",
                              },
                            ],
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.handleEdit(scope.row)
                              },
                            },
                          },
                          [
                            _c(
                              "span",
                              { staticStyle: { color: "#409eff !important" } },
                              [_vm._v(_vm._s(_vm.$t("GlobalSetObj.edit")))]
                            ),
                          ]
                        )
                      : _vm._e(),
                    scope.row.status === 0 || scope.row.status === 2
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "permit",
                                rawName: "v-permit:remove",
                                value:
                                  "btn:invoiceCenter:pushConfiguration:updateStatus",
                                expression:
                                  "'btn:invoiceCenter:pushConfiguration:updateStatus'",
                                arg: "remove",
                              },
                            ],
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.handleUpdateStatus(scope.row)
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("GlobalSetObj.enable")) + " "
                            ),
                          ]
                        )
                      : _vm._e(),
                    scope.row.status === 1
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "permit",
                                rawName: "v-permit:remove",
                                value:
                                  "btn:invoiceCenter:pushConfiguration:updateStatus",
                                expression:
                                  "'btn:invoiceCenter:pushConfiguration:updateStatus'",
                                arg: "remove",
                              },
                            ],
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.handleUpdateStatus(scope.row)
                              },
                            },
                          },
                          [
                            _c(
                              "span",
                              { staticStyle: { color: "#cb272d !important" } },
                              [_vm._v(_vm._s(_vm.$t("GlobalSetObj.disable")))]
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }